import { Fragment } from "react";
import { useSelector } from "react-redux";
import { ReportingWidget } from "./reportingwidget";
import { WIDGET_DATE_CARD } from "./utils";
import { formatDate, dateFormats, getThemeColors, isEmptyObject } from "../../lib/utils";

const CardDateWidgetContent = props => {
    const {
        id, 
        fontSize, fontIsBold, fontIsUnderline, fontIsItalic, fontColor, 
        dateFormat, 
        data, schema,
    ...other } = props;

    const currentTheme = useSelector(state => state.currentTheme);
    
    const fontColors = getThemeColors(currentTheme);
    let resolvedColor = fontColors.find(e => e.id == fontColor).color;

    let resolvedDateFormat = dateFormats.find (e => e.id == dateFormat).title;

    //console.log("CARDDATE", data)
    let resolvedData = (!data || isEmptyObject(data)) ? "Null" : formatDate(data, resolvedDateFormat);

    return (
        <Fragment>
           <div className={`card-date-content card-date-content-${id}`} 
                style={{
                    fontSize: fontSize, color: resolvedColor, 
                    textDecoration: fontIsUnderline ? "underline" : "none", 
                    fontStyle: fontIsItalic ? "italic" : "normal", 
                    fontWeight: fontIsBold ? 700 : 500
                }}>
                {resolvedData}
            </div>
            <style>
                {
                    `
                        .card-date-content
                        {
                            text-align: center;       
                            flex: 1;
                            display: flex;
                            justify-content: center;
                            align-items: center;                   
                        }
                    `
                }
            </style>
        </Fragment>
    );
};

export const CardDateWidget = props => {
    const {    
        id,
        mode, 
        loaded, loading, errorText, canceled,
        backgroundColor, title, titleFontSize, titleFontIsBold, titleFontIsUnderline, titleFontIsItalic, titleFontColor,
        getContextMenu, onMenuItemClick,
        onWidgetSelect, onWidgetUnSelect, onDoubleClick, ...other} = props;

    return (
        <Fragment>
             <ReportingWidget id={id} widgetTypeId={WIDGET_DATE_CARD}
             mode={mode} loaded={loaded} loading={loading} errorText={errorText} canceled={canceled}
             backgroundColor={backgroundColor} 
             title={title} titleFontSize={titleFontSize} titleFontIsBold={titleFontIsBold} titleFontIsUnderline={titleFontIsUnderline} 
             titleFontIsItalic={titleFontIsItalic} titleFontColor={titleFontColor}
             getContextMenu={getContextMenu} onMenuItemClick={onMenuItemClick} onWidgetSelect={onWidgetSelect} onWidgetUnSelect={onWidgetUnSelect} 
             onDoubleClick={onDoubleClick}>
                <CardDateWidgetContent {...props}/>
            </ReportingWidget>
            <style>
                {
                    `
                        
                    `
                }
            </style>
        </Fragment>
    );
};